import chainList from './chains';

const defaultChainList = chainList.map((chain) => chain.chain);

export default defaultChainList;
